import { RoleModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";
export class RoleRepo extends BaseDataRepository<RoleModel> {
  protected baseUrl = 'role';
}

export default RoleRepo;
